class Header {
	isNavOpen = false;
	stateClasses = {
		navOpen: 'nav-open',
		navigationLinkActive: 'navigation__link--active',
	};
	constructor($el) {
		this.$el = $el;
		this.$hamburger = this.$el.find('[data-header="hamburger"]');
		this.$navigationLinks = this.$el.find('[data-header="navigation-link"]');
		this.init();
	}

	init = () => {
		this.$hamburger.on('click', this.handleHamburgerClick);
	};

	handleHamburgerClick = () => {
		// open/close navigation
		if (!this.isNavOpen) {
			this.openNavigation();
		} else {
			this.closeNavigation();
		}
	};

	openNavigation = () => {
		this.isNavOpen = true;
		window._$html.addClass(this.stateClasses.navOpen);
	};

	closeNavigation = () => {
		this.isNavOpen = false;
		window._$html.removeClass(this.stateClasses.navOpen);
	};

	handleActiveClass = id => {
		console.log('handleActiveClass', id);

		this.$navigationLinks.removeClass(this.stateClasses.navigationLinkActive);

		// filter navigation links by id
		const $activeLink = this.$navigationLinks.filter(
			`[data-header="navigation-link"][data-id="${id}"]`
		);

		// add active class to active link
		$activeLink.addClass(this.stateClasses.navigationLinkActive);
	};
}

export default Header;
